<template>
    <div class="automation-button-wrapper">
        <a-popover
            v-model="visible"
            trigger="click"
            placement="bottom"
            overlayClassName="automation-popover zero-padding"
        >
            <template slot="content">
                <div class="automation-list">
                    <div
                        v-for="automation in automations"
                        :key="automation.id"
                        class="automation-item"
                        @click="selectAutomation(automation)"
                    >
                        <atomic-power class="myIcon ml-2" style="fill: var(--color-icon-primary-default)" />
                        {{ automation.name }}
                    </div>
                    <a-divider />
                    <div class="automation-item new" @click="showCreateAutomationModal">
                        {{ $t("message.newAutomation") }}
                    </div>
                </div>
            </template>
            <SupsisButton class="automation-trigger-button">
                <atomic-power class="myIcon" style="fill: var(--color-icon-primary-default)" />
                <span>{{ $t("message.automations") }}</span>
            </SupsisButton>
        </a-popover>

        <Modal2
            v-if="createAutomationModalVisible"
            :title="$t('message.createProfileAutomation')"
            :show-footer="false"
            @close="createAutomationModalVisible = false"
            @cancel="createAutomationModalVisible = false"
        >
            <a-alert
                type="info"
                show-icon
                :message="$t('message.profileButtonClicked')"
                :description="$t('message.profileButtonDescription')"
                class="mb-4"
            />
            <a-input v-model="newAutomationName" :placeholder="$t('message.automationName')" />
            <div class="mt-4 text-right">
                <a-button @click="createAutomationModalVisible = false" class="mr-2">{{
                    $t("message.cancel")
                }}</a-button>
                <a-button type="primary" @click="createAutomation">{{ $t("message.create") }}</a-button>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { AutomationEventTypes } from "../../views/Pages/Automation/utils/AutomationModuleTypes";
import { mapActions } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";
import Modal2 from "./Modal2.vue";
import { AUTOMATION_API } from "../../api/automation";
export default {
    name: "ContactProfileAutomationButton",
    components: {
        SupsisButton,
        Modal2,
    },
    props: {
        contactId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            visible: false,
            createAutomationModalVisible: false,
            newAutomationName: "",
        };
    },
    computed: {
        ...mapState({
            automations: (state) =>
                state.automation.automations.filter(
                    (x) =>
                        x.options?.trigger === "event" &&
                        x.options?.event?.type === AutomationEventTypes.CONTACT.PROFILE_BUTTON_CLICKED &&
                        x.published
                ),
        }),
    },
    methods: {
        ...mapActions({
            syncAutomations: "automation/syncAutomations",
        }),
        toggleAutomationList() {
            this.visible = !this.visible;
        },
        selectAutomation(automation) {
            this.visible = false;
            sendSocketMessage("automation run-profile-button", {
                automationId: automation._id,
                siteId: this.$store.state.site.site._id,
                userId: this.$store.state.auth.user._id,
                contactId: this.contactId,
            });
        },
        showCreateAutomationModal() {
            this.createAutomationModalVisible = true;
            this.newAutomationName = this.$t("message.untitledAutomation");
            this.visible = false;
        },
        gotoAutomation(automation) {
            this.$router.push(`/automations/${automation._id}/design`);
        },
        async createAutomation() {
            const name = this.newAutomationName;
            const event = AutomationEventTypes.CONTACT.PROFILE_BUTTON_CLICKED;
            const payload = { contactId: this.contactId };

            try {
                const automation = await AUTOMATION_API.createEmptyEventAutomation(name, event, payload);
                this.$message.success("Automation created successfully");
                this.createAutomationModalVisible = false;
                this.newAutomationName = "";
                this.syncAutomations();
                setTimeout(() => {
                    this.gotoAutomation(automation);
                }, 1000);
            } catch (error) {
                this.$message.error(this.$t("automation.automationCouldNotBeCreated"));
                console.error("Error while creating automation", error);
            }
        },
    },
    created() {
        if (this.automations.length === 0) {
            this.syncAutomations();
        }
    },
};
</script>

<style lang="scss" scoped>
.automation-button-wrapper {
    position: relative;
    display: inline-block;
}

.automation-list {
    min-width: 200px;

    .automation-item {
        padding: 8px 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 5px;

        &:hover {
            background-color: var(--color-bg-neutral-default);
        }

        &.new {
            color: var(--color-text-primary-default);
            font-weight: 500;
        }
    }
    .ant-divider {
        margin: 0;
    }
}

:deep(.automation-popover) {
    .ant-popover-inner-content {
        padding: 0;
    }
}
</style>
